import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { VERIFICATION_MODAL_ROUTE } from "@helpers/constants";
import { UntilDestroy } from "@ngneat/until-destroy";
import { UserService } from "@main-services/user.service";
import { combineLatest, Observable } from "rxjs";
import { User, UserVerificationState } from "@models/user";
import { filter, map } from "rxjs/operators";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";
import { VerificationModalFacade } from "@modules/verification/modal/state/verification-modal.facade";

@UntilDestroy()
@Component({
	selector: "verification-banner",
	templateUrl: "./verification-banner.component.html",
	styleUrls: ["../../../../theme//shared/banner-card.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class VerificationBannerComponent {
	public verification$: Observable<VerificationBannerModel> = combineLatest([
		this.userService.verificationState$,
		this.profileFacade.getProfile$()
	]).pipe(
		filter((profile) => !!profile),
		map(([state, profile]) => {
			const isVerificationPending = state === UserVerificationState.PENDING_APPROVAL;
			const isNotYetVerified = User.isNotYetVerified(state) && !this.userService.hasIgnoredVerify;
			const firstName = profile?.forename;
			return { isVerificationPending, isNotYetVerified, firstName };
		})
	);

	public constructor(
		private userService: UserService,
		private profileFacade: NewProfileFacade,
		private verificationModalFacade: VerificationModalFacade,
		private router: Router
	) {}

	public verify(): void {
		if (!this.verificationModalFacade.openVerification()) {
			this.router.navigate(VERIFICATION_MODAL_ROUTE, {
				skipLocationChange: true
			});
		}
	}
}

export interface VerificationBannerModel {
	isVerificationPending: boolean;
	isNotYetVerified: boolean;
	firstName: string;
}
